@use 'sass:math';
@use 'vars';

// Timing
$container-rotate-timing: 1600ms;
$loader-fill-unfill-rotate-timing: 4800ms;

$loader-left-spin: math.div($loader-fill-unfill-rotate-timing, 4);
$loader-right-spin: math.div($loader-fill-unfill-rotate-timing, 4);

$default-size: 25px;

.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: fit-content;
  min-width: fit-content;

  // Fixes a strange bug where the browser thinks there's overflow as ir rotates, causing some areas to become scrollable
  overflow: hidden;

  &--fixed {
    position: fixed;
    height: 100vh;
    width: 100vw;
  }
}

.loader {
  height: $default-size;
  min-height: $default-size;
  width: $default-size;
  min-width: $default-size;
  animation: container-rotate #{$container-rotate-timing} linear infinite;

  &__line {
    position: absolute;
    width: 100%;
    height: 100%;
    border-color: vars.$primary;
    animation: fill-unfill-rotate #{$loader-fill-unfill-rotate-timing} cubic-bezier(0.4, 0, 0.2, 1) infinite both;
  }

  &__cog {
    display: inline-block;
    position: relative;
    width: 50%;
    height: 100%;
    overflow: hidden;
    border-color: inherit;
  }

  &__cog-inner {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    width: 200%;
    height: 100%;
    box-sizing: border-box;
    border-width: 3px;
    border-style: solid;
    border-color: inherit;
    border-bottom-color: transparent;
    border-radius: 50%;

    &--left {
      border-right-color: transparent;
      transform: rotate(129deg);
      animation: left-spin #{$loader-left-spin} cubic-bezier(0.4, 0, 0.2, 1) infinite both;
    }

    &--right {
      left: -100%;
      border-left-color: transparent;
      transform: rotate(-129deg);
      animation: right-spin #{$loader-right-spin} cubic-bezier(0.4, 0, 0.2, 1) infinite both;
    }

    &--center {
      width: 1000%;
      left: -450%;
    }
  }

  &__ticker {
    position: absolute;
    top: 0;
    left: 45%;
    width: 10%;
    height: 100%;
    overflow: hidden;
    box-sizing: border-box;
    border-color: inherit;
  }
}

// Animations
@keyframes container-rotate {
  to {
    transform: rotate(360deg);
  }
}

@keyframes fill-unfill-rotate {
  12.5% {
    transform: rotate(135deg);
  }
  25% {
    transform: rotate(270deg);
  }
  37.5% {
    transform: rotate(405deg);
  }
  50% {
    transform: rotate(540deg);
  }
  62.5% {
    transform: rotate(675deg);
  }
  75% {
    transform: rotate(810deg);
  }
  87.5% {
    transform: rotate(945deg);
  }
  to {
    transform: rotate(1080deg);
  }
}

@keyframes left-spin {
  0% {
    transform: rotate(130deg);
  }
  50% {
    transform: rotate(-5deg);
  }
  to {
    transform: rotate(130deg);
  }
}

@keyframes right-spin {
  0% {
    transform: rotate(-130deg);
  }
  50% {
    transform: rotate(5deg);
  }
  to {
    transform: rotate(-130deg);
  }
}
